import { MouseEventHandler } from 'react';
import {
  useRoute,
  Link as WouterLink,
  LinkProps as WouterLinkProps,
} from 'wouter';
import {
  Link as ChakraLink,
  LinkProps as ChakraLinkProps,
  forwardRef,
} from '@chakra-ui/react';

type LinkProps = Omit<ChakraLinkProps, 'href'> & Pick<WouterLinkProps, 'href'>;

const Link = forwardRef<LinkProps, 'a'>(
  ({ href, children, onClick, ...rest }: LinkProps, ref) => {
    const [isActive] = useRoute(href || '');
    const handleClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
      if (onClick) {
        onClick(event);
      }
    };

    return (
      <WouterLink href={href || ''}>
        <ChakraLink
          // display="flex-inline"
          // alignItems="center"
          {...(isActive && {
            'data-active': 'data-active',
          })}
          ref={ref}
          onClick={handleClick}
          {...rest}
        >
          {children}
        </ChakraLink>
      </WouterLink>
    );
  },
);

export default Link;
